export default function ajaxSpinner(rootDom) {
    const SELECTOR = {
        LOADING: '_ajax-loading',
        SPINNER: 'ajaxspinner',
        VISIBLE: '_visible',
    };
    const $root = $(rootDom);
    let spinnerDom = document.querySelector(`.${SELECTOR.SPINNER}`);
    let isInside = false;
    let isLoading = false;
    let mouseX = 0;
    let mouseY = 0;


    if (!spinnerDom) {
        App.B.append(`<div class="${SELECTOR.SPINNER}"><div class="spinner"><div class="dot1"></div><div class="dot2"></div></div></div>`);
        spinnerDom = document.querySelector(`.${SELECTOR.SPINNER}`);

        const moveCursor = (e)=> {
            mouseX = e.clientX;
            mouseY = e.clientY;

            if (isLoading) {
                setSpinnerPosition(mouseX, mouseY);
            }
        };

        window.addEventListener('mousemove', moveCursor);
    }

    $root
        .on('mouseenter', () => {
            isInside = true;
            showSpinner();
        })
        .on('mouseleave', () => {
            isInside = false;
            hideSpinner();
        });


    // PRIVATE

    function setSpinnerPosition(x, y) {
        spinnerDom.style.transform = `translate3d(${x}px, ${y}px, 0)`;
    }

    function showSpinner() {
        if (isInside && isLoading) {
            setSpinnerPosition(mouseX, mouseY);
            spinnerDom.classList.add(SELECTOR.VISIBLE);
        }
    }

    function hideSpinner() {
        spinnerDom.classList.remove(SELECTOR.VISIBLE);
    }


    // PUBLIC

    function show() {
        isLoading = true;
        rootDom.classList.add(SELECTOR.LOADING);
        spinnerDom.style.transitionDelay = '0.3s';
        showSpinner();
        setTimeout(() => {
            spinnerDom.style.transitionDelay = '';
        }, 100);
    }

    function hide() {
        isLoading = false;
        hideSpinner();
        setTimeout(() => {
            rootDom.classList.remove(SELECTOR.LOADING);
        }, 100);
    }

    return {
        show,
        hide
    };
}
